<template>
  <div
    class="w-screen"
    style="background-color: #01798A;"
  >
    <!--        Mobile-->
    <div class="pt-12 pb-4 md:hidden">
      <div
        class="max-w-7xl mx-4 rounded-lg"
        style="background-color: #E6F2F3;"
      >
        <h1 class="py-10 pl-4 text-5xl">
          {{ headline }}
        </h1>
        <div class="flex-col pb-6">
          <div class="w-full flex flex-col">
            <div class="mx-4 p-5 bg-white rounded-lg flex justify-between">
              <h2 class="text-xl font-semibold">
                Totalpris
              </h2>
              <p class="text-xl font-semibold">
                {{ prices.amount_pr_pax }},- per person
              </p>
            </div>
            <div class="mx-4 py-3 px-5 my-6 bg-white rounded-lg flex flex-col">
              <h2 class="font-semibold text-xl">
                Totalprisen inkluderer
              </h2>
              <ul
                v-for="list in prices.data.price_bullets"
                class="list-disc pl-7 text-lg"
              >
                <li>{{ list }}</li>
              </ul>
            </div>
            <div
              v-for="extra in prices.data.optional_additions"
              class="mx-4 p-4 mb-4 flex items-center h-full bg-white rounded-lg"
            >
              <span>
                <svg
                  width="18"
                  height="17"
                  viewBox="0 0 18 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00002 1L3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16H14C14.4603 16 14.8334 15.6269 14.8334 15.1667V6.83333L9.00002 1Z"
                    fill="white"
                  />
                  <path
                    d="M1.5 8.5L3.16667 6.83333M3.16667 6.83333L9.00002 1L14.8334 6.83333M3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002M14.8334 6.83333L16.5 8.5M14.8334 6.83333V15.1667C14.8334 15.6269 14.4603 16 14 16H11.5M6.50002 16C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16M6.50002 16H11.5"
                    stroke="#212121"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="w-full flex justify-between">
                <p class="text-lg ml-5 font-semibold">
                  Tillegg for {{ extra.text }}
                </p>
                <p class="text-lg ml-5 font-semibold">+ {{ extra.amount }},- {{ extra.priceOption }}</p>
              </span>
            </div>
          </div>
          <div>
            <div class="mx-4 px-1 bg-white rounded-lg flex flex-col">
              <h2 class="p-4 font-semibold text-xl">
                Sammendrag
              </h2>
              <div class="flex w-2/3 justify-between px-4">
                <p class="text-lg">
                  Antall Reisende
                </p>
                <p class="font-semibold text-lg">
                  {{ prices.pax }}
                </p>
              </div>
              <div class="flex w-2/3 justify-between px-4 mt-1">
                <p class="text-lg">
                  Antall netter
                </p>
                <p class="font-semibold text-lg">
                  {{ nights }}
                </p>
              </div>
              <div class="p-4 mt-6 text-lg" style="white-space: pre-wrap;">
                  {{ prices.data.summary }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="max-w-7xl mx-auto">
        <div
          class="flex-col mx-4 mt-6 bg-white rounded-lg"
        >
          <div class="h-full w-full py-7 border-b flex flex-col items-center justify-center">
            <figure>
              <img
                :src="prices.creator.profile_photo_url"
                :alt="prices.creator.name"
                class="h-48 w-48 rounded-full"
              >
            </figure>
            <div class="flex flex-col text-lg items-center">
              <p class="mt-6">
                Med vennlig hilsen
              </p>
              <p class="font-semibold mb-6">
                {{ prices.creator.name }}
              </p>
<!--              <p class="font-semibold underline">-->
<!--                {{ guide.phone }}-->
<!--              </p>-->
              <p class="font-semibold underline">
                {{ prices.creator.email }}
              </p>
            </div>
          </div>
          <div
            class="h-full w-full text-lg p-7 flex-col items-center"
          >
<!--            <p class="flex justify-center">-->
<!--              Org.nr {{ company.org }}-->
<!--            </p>-->
            <p class="flex justify-center">
              Tilbudet er levert av: {{ prices.project.team.name }}
            </p>
<!--            <a-->
<!--              href="#"-->
<!--              class="underline-none flex justify-center"-->
<!--            >Personvern og Cookies</a>-->
          </div>
        </div>
      </div>
      <div class="max-w-7xl mx-auto flex justify-center pt-6 pb-10">
        <button
          @click="scrollToTop"
          type="button"
          class="w-full mx-4 border border-white p-4 rounded-lg text-white text-lg font-semibold"
        >
          Gå til toppen
        </button>
      </div>
    </div>

    <!--        Desktop-->
    <div class="hidden w-full max-w-7xl mx-auto pt-12 pb-4 md:flex">
      <div
        class="mx-14 w-full rounded-lg"
        style="background-color: #E6F2F3;"
      >
        <h1 class="pt-10 pb-8 pl-6 text-4xl ml-4">
          {{ headline }}
        </h1>
        <div class="flex w-full">
          <div class="w-1/2 flex flex-col">
            <div class="ml-10 mt-6 p-4 bg-white rounded-lg flex justify-between">
              <h2 class="text-xl font-semibold">
                Totalpris
              </h2>
              <p class="text-xl font-semibold">
                {{ prices.amount_pr_pax }},- per person
              </p>
            </div>
            <div class="ml-10 p-4 my-6 bg-white rounded-lg flex flex-col">
              <h2 class="p-4 font-semibold text-xl">
                Totalprisen inkluderer
              </h2>
              <div class="w-full grid grid-cols-2">
                <ul
                  v-for="list in prices.data.price_bullets"
                  class="list-disc pl-10"
                >
                  <li class="">
                    {{ list }}
                  </li>
                </ul>
              </div>
            </div>
            <div
              v-for="extra in prices.data.optional_additions"
              class="ml-10 mb-6 h-12 items-center flex bg-white rounded-lg"
            >
              <div class="h-full w-2/3 border-r flex items-center ml-4 lg:w-1/2">
                <svg
                  width="18"
                  height="17"
                  class="mr-2"
                  viewBox="0 0 18 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00002 1L3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16H14C14.4603 16 14.8334 15.6269 14.8334 15.1667V6.83333L9.00002 1Z"
                    fill="white"
                  />
                  <path
                    d="M1.5 8.5L3.16667 6.83333M3.16667 6.83333L9.00002 1L14.8334 6.83333M3.16667 6.83333V15.1667C3.16667 15.6269 3.53977 16 4.00001 16H6.50002M14.8334 6.83333L16.5 8.5M14.8334 6.83333V15.1667C14.8334 15.6269 14.4603 16 14 16H11.5M6.50002 16C6.96025 16 7.33335 15.6269 7.33335 15.1667V11.8333C7.33335 11.3731 7.70645 11 8.16669 11H9.83336C10.2936 11 10.6667 11.3731 10.6667 11.8333V15.1667C10.6667 15.6269 11.0398 16 11.5 16M6.50002 16H11.5"
                    stroke="#212121"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p class="text-md font-semibold">
                  Tillegg for {{ extra.text }}
                </p>
              </div>
              <div class="w-1/3 flex justify-end mr-4 lg:w-1/2">
                <p class="text-md font-semibold">
                  + {{ extra.amount }},- {{ extra.priceOption }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="flex w-1/2"
          >
            <div class="w-full mx-6 my-6 p-4 bg-white rounded-lg flex flex-col">
              <h2 class="p-4 font-semibold text-xl">
                Sammendrag
              </h2>
              <div class="flex w-2/3 justify-between px-4">
                <p class="text-md">
                  Antall Reisende
                </p>
                <p class="font-semibold">
                  {{ prices.pax }}
                </p>
              </div>
              <div class="flex w-2/3 justify-between px-4 mt-3">
                <p class="text-md">
                  Antall netter
                </p>
                <p class="font-semibold">
                  {{ nights }}
                </p>
              </div>
              <div class="p-4 mt-6" style="white-space: pre-wrap;">
                  {{ prices.data.summary }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="max-w-7xl mx-auto">
      <div
        class="hidden h-38 mx-14 mt-6 bg-white rounded-lg md:flex"
      >
        <div class="h-full w-1/2 p-7 border-r flex items-center">
          <figure>
            <img
              :src="prices.creator.profile_photo_url"
              :alt="prices.creator.name"
              class="ml-10 h-32 w-32 rounded-full"
            >
          </figure>
          <div class="flex flex-col ml-10">
            <p class="mb-4">
              Med vennlig hilsen
            </p>
            <p class="font-semibold">
              {{ prices.creator.name }}
            </p>
<!--            <p class="font-semibold underline">-->
<!--              {{ guide.phone }}-->
<!--            </p>-->
            <p class="font-semibold underline">
              {{ prices.creator.email }}
            </p>
          </div>
        </div>
        <div
          class="w-1/2 p-7"
        >
<!--          <p class="mt-12">-->
<!--            Org.nr {{ company.org }}-->
<!--          </p>-->
          <p class="h-full flex flex-col justify-end">Tilbudet er levert av: {{ prices.project.team.name }}</p>
<!--          <a-->
<!--            href="#"-->
<!--            class="underline-none"-->
<!--          >Personvern og Cookies</a>-->
        </div>
      </div>
    </div>
    <div class="hidden w-full justify-center py-10 md:flex">
      <button
        @click="scrollToTop"
        type="button"
        class="border border-white p-2 rounded-lg text-white text-sm"
      >
        Gå til toppen
      </button>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  prices: {
    type: Object,
    required: true
  },
  headline: {
    type: String,
    required: true
  }
})

const start = new Date(props.prices.start_date)
const end = new Date(props.prices.end_date)
let nights = (end - start) / (1000 * 3600 * 24)

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

</script>
